import { Banner, TextLink, Typography } from 'darrius';
import { FormLead } from '../..';
import { formData } from '../../../locales/pt-BR';
import { ProspectHeroData } from '../../../data/home/homeData';

import styles from './ProspectHero.module.scss';

export const ProspectHero = () => {
  return (
    <Banner as="section" className={styles['prospect-home__hero']}>
      <img
        className={`${styles['hero__banner']} hide-mobile`}
        src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/pages/home/hero-banner.png`}
      />

      <div id="cadastro" className={styles['hero__form-container']}>
        <Typography.Title as="h1" size="4xl" className={styles['title-hero']}>
          {ProspectHeroData.title}
        </Typography.Title>
        <Typography.Text className={styles['subtitle-hero']}>
          {ProspectHeroData.subtitle}
        </Typography.Text>
        <Typography.Text className={styles['subtitle-hero']}>
          {ProspectHeroData.preDescription}
          <b> {ProspectHeroData.strongDescription} </b>
          {ProspectHeroData.description}
        </Typography.Text>

        <FormLead
          order="first_form"
          content={formData}
          direction="vertical"
          buttonText={ProspectHeroData.fistButtonText}
          showLgpdCheckbox
        />
        <div className={styles['text-link__hero']}>
          <TextLink
            className="text-link__hero"
            url={ProspectHeroData.secondButtonLink}
            text={ProspectHeroData.secondButtonText}
          />
        </div>
      </div>
    </Banner>
  );
};
